import React, { FC, useMemo } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';

interface Props {
  content: string;
  images: { [key: string]: string };
  translitName: string;
}

const ArticleContent: FC<Props> = ({ content, translitName, images }) => {
  const link = useMemo(
    () => `articles/large/${images[translitName]}`,
    [translitName]
  );
  return (
    <div>
      <NextImage
        alt={'my-first-aid-kit'}
        src={link}
        layout="responsive"
        height={552}
        width={1037}
      />
      <div
        className="fs-caption-reg text-mako pt-5 compendium-articleTitle compendium-articleList"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ArticleContent;
